import React from 'react';
import { Box, Typography } from '@mui/material';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { AppButton } from '../../../components/UI';

const ContractEndMessage = ({ contractEndMessage, handleRenewClick }) => {
  if (!contractEndMessage) return null;

  return (
    <Box
      sx={{
        borderRadius: '12px',
        background: contractEndMessage.backgroundColor,
        border: `1px solid ${contractEndMessage.color}`,
        px: 2,
        py: 1.5,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        flexWrap: 'wrap',
      }}
    >
      <Box sx={{ color: contractEndMessage.color, display: 'flex' }}>{contractEndMessage.icon}</Box>
      <Box sx={{ flex: 1, minWidth: 200 }}>
        <Typography sx={{ fontWeight: 700, color: contractEndMessage.color, fontSize: '0.9rem' }}>
          {contractEndMessage.text}
        </Typography>
        <Typography sx={{ fontSize: '0.76rem', color: '#475569' }}>
          La fiche est verrouillée : renouvelez ou changez le contrat pour pouvoir la modifier.
        </Typography>
      </Box>
      <AppButton size="small" startIcon={<AutorenewIcon />} onClick={handleRenewClick}>
        Renouveler
      </AppButton>
    </Box>
  );
};

export default ContractEndMessage;
